<template>
  <b-container class="py-4">
    <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
    <b-row>
      <b-col cols="auto" class="mr-auto">
        <h1 class="mb-3">Vesti</h1>
      </b-col>
      <b-col cols="auto">
        <AddNews />
      </b-col>
    </b-row>
    <router-view :key="$route.fullPath"></router-view>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import AddNews from "@/components/AddNews";

export default {
  components: {
    AddNews
  },
  data() {
    return {};
  },
  created() {
    const crumbs = [
      {
        html: "<i class='fas fa-home'></i>",
        to: { name: "home" }
      },
      {
        text: this.project_title,
        to: { name: "project" }
      },
      {
        text: "Vesti",
        to: { name: "news" },
        active: true
      }
    ];
    this.$store.commit("setBreadcrumbs", crumbs);
  },
  computed: {
    ...mapGetters({
      breadcrumbs: "breadcrumbs",
      project_title: "project/title"
    })
  }
};
</script>

<style>
</style>